// import React, { useEffect, useState } from "react";
// import "./Instructions.css";
// import Start_Btn from "../../common/start-btn/Start_Btn";
// import { useDispatch, useSelector } from "react-redux";
// import { GetAllTest, startTest } from "../../../redux/test";
// import { Getprofile } from "../../../redux/profile";
// import TimerModal from "../../modals/timer-modal/TimerModal";
// import { useNavigate } from "react-router-dom";
// import Common_Btn from "../../common/common-btn/Common_Btn";
// import Login_Modal from "../../modals/login-modal/Login_Modal";

// const Instructions = () => {
//   const dispatch = useDispatch();
//   const [showModal, setShowModal] = useState(false);
//   const [showModalLogin, setShowModalLogin] = useState(false);
//   const [expanded, setExpanded] = useState(false);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);

//   const navigate = useNavigate();

//   const getUserprofile = useSelector((state) => state?.profile?.getprofile);

//   console.log(getUserprofile, "getUserprofile");

//   const getAllExams = useSelector((state) => state?.test);

//   console.log(getAllExams, "getAllExams");

//   useEffect(() => {
//     dispatch(GetAllTest());
//     dispatch(Getprofile());
//   }, [dispatch]);

//   var HtmlToReactParser = require("html-to-react").Parser;
//   var htmlToReactParser = new HtmlToReactParser();

//   const onSubmit = async (id) => {
//     try {
//       const response = await dispatch(startTest({ id: id }));

//       if (response?.payload?.success) {
//         dispatch(GetAllTest());
//         setShowModal(true);
//         setTimeout(() => {
//           setShowModal(false);
//           navigate(`/test-page/${response?.payload?.data?.id}`);
//         }, 5000);
//       } else {
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   return (
//     <>
//       <section className="Instructions_holder">
//         {getAllExams?.data?.map((d, index) => (
//           <div className="instruction_section">
//             <div className="timer_holder">
//               <h1 className="text_name">{d?.name}</h1>
//               <div className="timer">
//                 <h2 className="title_cyan">
//                   Time:{" "}
//                   <span className="time">
//                     <b>{d?.time} Minutes</b>
//                   </span>
//                 </h2>
//               </div>
//             </div>

//             <h2 className="title_cyan">Instructions!</h2>
//             <p className="description_text">
//               {htmlToReactParser.parse(d?.instructions)}
//             </p>

//             <hr className="custom_divider" />

//             <h3 className="title_red">TRY NOT TO THINK ABOUT:</h3>
//             {/* <ol className="description_text"> */}
//             <p className="description_text">
//               {htmlToReactParser.parse(d?.try_not_to)}
//             </p>
//             {/* </ol> */}

//             <hr className="custom_divider" />

//             <h3 className="title_green">POINTS TO REMEMBER:</h3>
//             {/* <ol className="description_text"> */}
//             <p className="description_text">
//               {htmlToReactParser.parse(d?.points_to_remember)}
//             </p>
//             {/* </ol> */}

//             {getUserprofile?.user?.accept_or_reject == true ? (
//               <div className="btn_div">
//                 <Start_Btn
//                   text="Start Test"
//                   onClick={() => {
//                     onSubmit(d?.id);
//                   }}
//                 />
//               </div>
//             ) : (
//               <p style={{ color: "red", textAlign: "right" }}>
//                 <Common_Btn
//                   text="Login"
//                   onClick={() => {
//                     setShowModalLogin(true);
//                     setExpanded(false);
//                   }}
//                 />
//               </p>
//             )}
//             {/* <div className="btn_div">
//               <Start_Btn text="Start Test" link="/test-page" />
//             </div> */}
//           </div>
//         ))}

//         <TimerModal
//           show={showModal}
//           handleClose={() => setShowModal(false)}
//           message={"Successful"}
//         />

//         <Login_Modal
//           show={showModalLogin}
//           handleClose={() => setShowModalLogin(false)}
//           handleLogin={() => setIsLoggedIn(true)}
//         />
//       </section>
//     </>
//   );
// };

// export default Instructions;

import React, { useEffect, useState } from "react";
import "./Instructions.css";
import Start_Btn from "../../common/start-btn/Start_Btn";
import { useDispatch, useSelector } from "react-redux";
import { GetAllTest, startTest } from "../../../redux/test";
import { Getprofile } from "../../../redux/profile";
import TimerModal from "../../modals/timer-modal/TimerModal";
import { useNavigate } from "react-router-dom";
import Common_Btn from "../../common/common-btn/Common_Btn";
import Login_Modal from "../../modals/login-modal/Login_Modal";

const Instructions = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [showModalLogin, setShowModalLogin] = useState(false);
  const [testId, setTestId] = useState(null);

  const getUserprofile = useSelector((state) => state?.profile?.getprofile);
  const getAllExams = useSelector((state) => state?.test);

  useEffect(() => {
    dispatch(GetAllTest());
    dispatch(Getprofile());
  }, [dispatch]);

  const HtmlToReactParser = require("html-to-react").Parser;
  const htmlToReactParser = new HtmlToReactParser();

  const onSubmit = async (id) => {
    try {
      // ✅ Enter fullscreen
      if (!document.fullscreenElement) {
        try {
          await document.documentElement.requestFullscreen();
        } catch (err) {
          console.warn("Fullscreen blocked:", err);
        }
      }

      // ✅ Lock Escape key
      if (navigator.keyboard && navigator.keyboard.lock) {
        try {
          await navigator.keyboard.lock(["Escape"]);
        } catch (e) {
          console.warn("Keyboard lock failed", e);
        }
      }

      const response = await dispatch(startTest({ id }));

      if (response?.payload?.success) {
        const startedTestId = response?.payload?.data?.id;
        setTestId(startedTestId);
        setShowModal(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // ✅ After countdown
  const startTestAfterCountdown = () => {
    if (!testId) return;
    navigate(`/test-page/${testId}`);
  };

  // 🚫 Prevent tab switch
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        alert("Tab switching is not allowed!");
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  // 🚫 Prevent exiting fullscreen
  useEffect(() => {
    const handleFullscreenChange = () => {
      if (!document.fullscreenElement) {
        alert("Exiting fullscreen is not allowed!");
        document.documentElement.requestFullscreen();
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  // 🚫 Disable right click
  useEffect(() => {
    const handleRightClick = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handleRightClick);

    return () => {
      document.removeEventListener("contextmenu", handleRightClick);
    };
  }, []);

  // 🚫 Block keys
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Block F1–F12
      if (e.keyCode >= 112 && e.keyCode <= 123) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      // Block Ctrl combinations
      if (e.ctrlKey) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      // Block Alt combinations (not 100% but helps)
      if (e.altKey) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      // Block Escape
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      // Block specific keys manually
      const blockedKeys = [
        "F1",
        "F2",
        "F3",
        "F4",
        "F5",
        "F6",
        "F7",
        "F8",
        "F9",
        "F10",
        "F11",
        "F12",
        "Alt",
        "Meta",
      ];

      if (blockedKeys.includes(e.key)) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    };

    window.addEventListener("keydown", handleKeyDown, true);

    return () => {
      window.removeEventListener("keydown", handleKeyDown, true);
    };
  }, []);

  useEffect(() => {
    const handleKeyUp = (e) => {
      if ((e.keyCode >= 112 && e.keyCode <= 123) || e.ctrlKey || e.altKey) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    window.addEventListener("keyup", handleKeyUp, true);

    return () => {
      window.removeEventListener("keyup", handleKeyUp, true);
    };
  }, []);

  return (
    <>
      <section className="Instructions_holder">
        {getAllExams?.data?.map((d) => (
          <div className="instruction_section" key={d.id}>
            <div className="timer_holder">
              <h1 className="text_name">{d?.name}</h1>
              <div className="timer">
                <h2 className="title_cyan">
                  Time:{" "}
                  <span className="time">
                    <b>{d?.time} Minutes</b>
                  </span>
                </h2>
              </div>
            </div>

            <h2 className="title_cyan">Instructions!</h2>
            <p className="description_text">
              {htmlToReactParser.parse(d?.instructions)}
            </p>

            <hr className="custom_divider" />

            <h3 className="title_red">TRY NOT TO THINK ABOUT:</h3>
            <p className="description_text">
              {htmlToReactParser.parse(d?.try_not_to)}
            </p>

            <hr className="custom_divider" />

            <h3 className="title_green">POINTS TO REMEMBER:</h3>
            <p className="description_text">
              {htmlToReactParser.parse(d?.points_to_remember)}
            </p>

            {getUserprofile?.user?.accept_or_reject === true ? (
              <div className="btn_div">
                <Start_Btn text="Start Test" onClick={() => onSubmit(d?.id)} />
              </div>
            ) : (
              <p style={{ color: "red", textAlign: "right" }}>
                <Common_Btn
                  text="Login"
                  onClick={() => setShowModalLogin(true)}
                />
              </p>
            )}
          </div>
        ))}

        <TimerModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          onCountdownFinish={startTestAfterCountdown}
        />

        <Login_Modal
          show={showModalLogin}
          handleClose={() => setShowModalLogin(false)}
        />
      </section>
    </>
  );
};

export default Instructions;
